<template>
    <div class="contentbox">
      <div class="toptitle">
        <router-link tag="span" to="/commodity">&lt;</router-link>
        <span v-show="!state" class="personalicon" @click="reopenNewOrder">
          <img src="../assets/images/add.png" alt="">
        </span>
        <div v-show="!state" class="pcshow" @click="inorderlist">
          <img src="../assets/images/chat.png" alt="">
        </div>
        <div v-show="!state" class="personalicon" @click="showPersonalCenter">
          <img src="../assets/images/personal.png" alt="">
        </div>
      </div>
      <mt-popup
        v-model="popupVisible"
        :modal="false"
        position="right">
        <slot>
          <div class="PersonalCenter">
            <h1>个人中心</h1>
            <div>公司名称({{$store.state.loginuserdata.enterprise}})</div>
            <div>用户名称({{$store.state.loginuserdata.username}})</div>
            <div><mt-button @click="curtainlogout" type="danger">退出</mt-button></div>
            <div><mt-button @click="showPersonalCenter" type="primary">返回</mt-button></div>
          </div>
        </slot>
      </mt-popup>
      <!--属性-->
      <div class="maxobx">
        <!--属性列表-->
        <div class="attributebox">
         <div class="attributeitme"
              :key="index"
              v-for="(itme,index) in attribute"
              v-if="itme.product_attribute_name_title && itme.screen">
           <p class="attributename">{{itme.product_attribute_name_title}}</p>
           <ul>
             <li @click="onselect_attribute"
                 :data-att="itme.attribute_id"
                 :class="'attribute'+itme.attribute_id"
                 class="attribute" :key="i"
                 v-if="lsit"
                 v-for="(lsit,i) in itme.attribute_list">{{lsit}}</li>
           </ul>
         </div>
        </div>
        <!--产品列表-->
        <div class="commoditybox">
          <ul class="commodity">
            <router-link :key="index" v-for="(itme,index) in prodetail" tag="li"
                         :to="'/shop?id='+itme.expend_id+'&product_id='+itme.product_id">
              <img :src="itme.product_img"/>
              <p>{{itme.product_name}}</p>
              <p>{{itme.currency_symbol}} {{itme.expend_price}}</p>
            </router-link>
          </ul>
        </div>
      </div>


    </div>
</template>

<script>
  import {getSubproduct,curtainlogout} from '../assets/js/api'
  import {traditionalized} from '../assets/js/language'
  import ScrollPosition from '../assets/js/scroll-position'
  import $ from 'jquery'
  import {Popup, MessageBox } from 'mint-ui'
    export default {
        name: "commodity",
        data(){
          return{
            searchvalue:'',
            popupVisible:false,
            state:false,
            prodetail:[],
            attribute:[],
            alldata:[]
          }
        },
        components:{
          Popup,
          MessageBox,
        },
        mounted(){
          getSubproduct(this.$route.query.id).then((data)=>{
            console.log(data)
            if (data.attributeList.length){
              data.attributeList.map(itme=>{
                itme.product_attribute_name_title = itme.attribute_name
                itme.product_attribute_name = ''
                itme.screen = true
                delete itme.attribute_name
                let list3_index = [];
                itme.attribute_list.map((list3,index)=>{
                  itme.attribute_list[index] = list3.replace(/^\s|\s$/g,'')
                  let state = true
                  if (data.productList) {
                    data.productList.map(list=>{
                      let a = list.product_abbreviation.split('-')[1].split('×')
                      a.map(lsit2=>{
                        if (lsit2 === itme.attribute_list[index]) {
                          state = false
                        }
                      })
                    })
                  }

                  if (state){
                    list3_index.push(index)
                  }
                })
                if (list3_index.length) {
                  list3_index.map(i=>{
                    itme.attribute_list.splice(i,1,'')
                  })
                }
              })
            }
            this.attribute = data.attributeList
            this.prodetail = data.productList
            this.alldata = data.productList || []
          })
          ScrollPosition.get.call(this);
        },
        methods:{
          onselect_attribute(e){
           let attribute_id = $(e.target).data('att')
            let name = $(e.target).html()
            if ($(e.target)[0].className.indexOf('active') !== -1){
              $('.attribute' + attribute_id).removeClass('active')
            }
            else {
              $('.attribute' + attribute_id).removeClass('active')
              $(e.target).addClass('active')
              setTimeout(() => {
                $("html, body").animate({
                  scrollTop: $(e.target).offset().top
                },{
                  duration: 500,
                  easing: "swing"
                });
              }, 200)
            }
           this.attribute.map(itme=>{
             if (itme.attribute_id === attribute_id.toString()) {
               if ($(e.target)[0].className.indexOf('active') !== -1){
                 itme.product_attribute_name = name
               }
               else {
                 itme.product_attribute_name = ''
               }

             }
           })
           this.$store.commit('set_defaultAttributeValue',this.attribute)
            let alldata = JSON.parse(JSON.stringify(this.alldata))
            let temporary = []
            this.attribute.map(b=>{
              if (b.product_attribute_name !== ''){
                alldata.map((itme=>{
                  let list = itme.product_abbreviation.split('-')[1].split('×')
                  // console.log(list)
                  list.map(a=>{
                    if (a === b.product_attribute_name) {
                      temporary.push(itme)
                    }
                  })
                }))
                alldata = JSON.parse(JSON.stringify(temporary))
                temporary = []
              }
            })
            this.prodetail = alldata
            this.Filterattributes()
          },
          // 筛选选择后不需要的属性
          Filterattributes(){
            this.attribute.map(itme=>{
              if (itme.product_attribute_name === ''){
                itme.screen = false
                this.prodetail.map(list=>{
                  let product_arr_list = list.product_abbreviation.split('-')[1].split('×')
                  itme.attribute_list.map(listarr=>{
                    product_arr_list.map(producelistarr=>{
                      if (producelistarr === listarr) {
                        itme.screen = true
                      }
                    })
                  })
                })
              }
            })
          },
          reopenNewOrder(){
            if (this.$store.state.client){
              MessageBox({
                title: '提示',
                message: '您确定重开新单吗？',
                showCancelButton: true,
                confirmButtonText:"确定",
                cancelButtonText:"取消"
              }).then((confirm)=>{
                if (confirm === 'confirm'){
                  sessionStorage.removeItem('LocalShoppingCart');
                  sessionStorage.removeItem('order_id');
                  sessionStorage.removeItem('quotation_code');
                  this.$store.commit('res_state')
                  this.$router.push({ path: '/index'});
                }
              });
            }
            else {
              this.$confirm('您确定重开新单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                distinguishCancelAndClose: true,
                type: 'warning'
              }).then(() => {
                sessionStorage.removeItem('LocalShoppingCart');
                sessionStorage.removeItem('order_id');
                sessionStorage.removeItem('quotation_code');
                this.$store.commit('res_state')
                this.$router.push({ path: '/index'});
              }).catch((c) => {});
            }
          },
          onsearch(){
            let newprodetail = []
            for (let key in  this.searchprodetail) {
              if (traditionalized( this.searchprodetail[key].product_name).indexOf(traditionalized(this.searchvalue)) !== -1){
                newprodetail.push( this.searchprodetail[key])
              }
            }
            this.prodetail = newprodetail
            // this.prodetail = this.prodetail.filter((itme)=>{
            //   return itme.product_name.indexOf(this.searchvalue) === 0
            // })
          },
          showPersonalCenter(){
            this.popupVisible ? this.popupVisible = false : this.popupVisible = true
          },
          curtainlogout(){
            curtainlogout().then(data=>{
              sessionStorage.removeItem('LocalShoppingCart');
              sessionStorage.removeItem('order_id');
              localStorage.removeItem('logindata');
              localStorage.removeItem('userdata');
              this.$store.commit('res_state')
              this.$router.push({ path: '/'});
            })
          },
          inorderlist(){
            this.$store.commit('set_inorderilstroutername','seletcattribute?id='+this.$route.query.id)
            this.$router.push({ path: '/orderlist'});
          }
        },
      computed: {

      },
    }
</script>

<style scoped lang="less">
  @import "../assets/less/base";
  .contentbox{
    /*position: relative;*/
    width: 100%;
    .toptitle{
      position: fixed;
      z-index: 1;
      width: 80%;
      background-color: @maincolor;
      height: 52px;
      line-height: 52px;
      color: #fff;
      padding: 0 10%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      img{
        height: 46px;
      }
      .pcshow{
        @media (min-width: @screen-xs-max) {
          display: block !important;
        }
      }
      .personalicon{
        @media (min-width: @screen-xs-max) {
          display: block !important;
        }
        img{
          height: 32px;
        }
      }
      >span{
        font-size: 40px;
        cursor: pointer;
      }
      >div{
        /*width: 80%;*/
        transition: all 1s;
        /*margin-left: -100px;*/
        cursor: pointer;
      }
      >i{
        font-size: 30px;
        cursor: pointer;
      }
    }
    .PersonalCenter{
      background-color: #fff;
      height: 100vh;
      width: 100vw;
      padding-top: 30%;
      text-align: center;
      h1{
        margin: 30px auto;
        font-size: 0.5rem;
      }
      div{
        font-size: 0.3rem;
        margin-top: 30px;
      }
    }
    .maxobx{
      margin-top: 60px;
      /*<!--@media (min-width: @screen-xs-max) {-->*/
        /*<!--display: flex;-->*/
      /*<!--}-->*/
      .attributebox{
        padding: 0 10px;
        @media (min-width: @screen-xs-max) {
          /*width: 50%;*/
          /*margin: 0.2rem auto;*/
        }
        .attributeitme{
          margin-bottom: 20px;
          .attributename{
            margin-bottom: 10px;
            font-weight: bold;
          }
          ul{
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: flex-start;
            li.attribute{
              cursor: pointer;
              padding: 5px 10px;
              border: 1px solid #e8e8e8;
              margin-right: 15px;
              margin-bottom: 10px;
              &.active{
                border: 1px solid #17e4e6;
                color: #17e4e6;
              }
            }
          }
        }
      }
      .commoditybox{
        ul.commodity{
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          width: 96%;
          margin: 0.2rem auto;
          li{
            width: 41%;
            /*height: 90px;*/
            cursor: pointer;
            margin-top: 8px;
            padding: 0.2rem;
            box-shadow: 0px 2px 5px 2px #e8e8e8;
            margin-left: 2%;
            @media (min-width: @screen-xs-max) {
              width: 21%;
            }
            img{
              width: 100%;
            }
            p{
              margin-top: 0.1rem;
              font-size: 14px;
            }
          }
        }
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/components/seletcattribute.vue